import { useMemo } from "react";

import SkeletonManageView, { TSkeletonListType } from "./SkeletonManageView";

import { useTheme } from "@/providers/ThemeProvider";

/**
 *
 */
interface Props {
  type: TSkeletonListType;
}

/**
 * Container component for skeleton loading placeholder in manage screens
 * @param root0 - The component props
 * @param root0.type - Type of skeleton list to display (manage-orgs, manage-users, etc.)
 */
const SkeletonManageContainer = ({ type }: Props) => {
  const { resolvedTheme } = useTheme();
  const isDark = useMemo(() => resolvedTheme === "dark", [resolvedTheme]);
  const bgColor = useMemo(
    () => (isDark ? "bg-surface-strong" : "bg-surface-muted"),
    [isDark]
  );

  return <SkeletonManageView type={type} bgColor={bgColor} />;
};

export default SkeletonManageContainer;
